<div class="main main-farm farm-detail-view" *ngIf="farm">
    <div class="main-farm-top farm-detail-top">
        <div class="farm-header-with-back">
            <div class="farm-title-description">
                <h2>{{ farm.name }}</h2>
                <p>Farm Details Overview</p>
            </div>
        </div>
    </div>

    <div class="main-farm-group farm-detail-group">
        <section class="farm-section">
            <div class="section-heading">
                <h3>Farm Information</h3>
            </div>

            <div class="farm-top-group">
                <div class="farm-form-row">
                    <div class="input-group-farm">
                        <label>Name</label>
                        <div class="display-field">{{ farm.name }}</div>
                    </div>
                    <div class="input-group-farm">
                        <label>Address</label>
                        <div class="display-field">{{ farm.address }}</div>
                    </div>
                </div>

                <div class="farm-form-row">
                    <div class="input-group-farm">
                        <label>Bird Type</label>
                        <div class="display-field">
                            {{ getBirdTypeName(farm.type) }}
                        </div>
                    </div>
                    <!-- BREED FIELD - COMMENTED OUT - TO BE ADDED LATER -->
                    <!-- <div class="input-group-farm">
                        <label>Breed</label>
                        <div class="display-field">
                            {{ getBreedName(farm.breedId) }}
                        </div>
                    </div> -->
                    <div class="input-group-farm">
                        <label>Size (sq ft)</label>
                        <div class="display-field">{{ farm.size }}</div>
                    </div>
                    <div class="input-group-farm">
                        <label>Length (ft)</label>
                        <div class="display-field">{{ farm.length }}</div>
                    </div>
                    <div class="input-group-farm">
                        <label>Width (ft)</label>
                        <div class="display-field">{{ farm.width }}</div>
                    </div>                    
                    <div class="input-group-farm">
                        <label>Water Tank Capacity (l)</label>
                        <div class="display-field">{{ farm.waterTank }}</div>
                    </div>                                      
                    <div class="input-group-farm">
                        <label>Diesel Tank Capacity (l)</label>
                        <div class="display-field">{{ farm.dieselTank }}</div>
                    </div>                                    
                    <div class="input-group-farm">
                        <label>Water Tank Height (mm)</label>
                        <div class="display-field">{{ farm.waterTankHeight }}</div>
                    </div>                                                       
                    <div class="input-group-farm">
                        <label>Diesel Tank Height (mm)</label>
                        <div class="display-field">{{ farm.dieselTankHeight }}</div>
                    </div>
                </div>
            </div>
        </section>

        <section
            class="farm-section"
            *ngIf="farm.farmHouses && farm.farmHouses.length > 0"
        >
            <div class="section-heading">
                <h3>Farm Houses ({{ farm.farmHouses.length }})</h3>
            </div>

            <div class="farm-farm-house-group">
                <div
                    class="farmhouse"
                    *ngFor="let house of farm.farmHouses; let i = index"
                >
                    <ng-container
                        *ngIf="house.name?.toLowerCase() !== 'house 0'"
                    >
                        <div class="farmhouse-header-row">
                            <div class="accordion-header">
                                <h3>{{ house.name }}</h3>
                            </div>
                        </div>
                        <div class="accordion-body show">
                            <div class="farmhouse-form-row">
                                <div class="input-group-farm">
                                    <label>House Name</label>
                                    <div class="display-field">
                                        {{ house.name }}
                                    </div>
                                </div>
                                <div class="input-group-farm">
                                    <label>Length (ft)</label>
                                    <div class="display-field">
                                        {{ house.length }}
                                    </div>
                                </div>
                                <div class="input-group-farm">
                                    <label>Width (ft)</label>
                                    <div class="display-field">
                                        {{ house.width }}
                                    </div>
                                </div>
                                <div class="input-group-farm">
                                    <label>feeding Silo Capacity</label>
                                    <div class="display-field">
                                        {{ house.feedingSiloCapacity }}
                                    </div>
                                </div>
                            </div>

                            <div
                                class="partition"
                                *ngFor="
                                    let partition of house.farmHousePartitions;
                                    let j = index
                                "
                            >
                                <div class="partition-header">
                                    <h4>
                                        Partition {{ j + 1 }} —
                                        {{ partition.name }}
                                    </h4>
                                    <span
                                        class="partition-status"
                                        [class.active]="
                                            partition.capacityStatus
                                        "
                                    >
                                        <i class="fas fa-circle"></i>
                                        {{
                                            partition.capacityStatus
                                                ? 'Active'
                                                : 'Inactive'
                                        }}
                                    </span>
                                </div>
                                <div class="partition-form-row">
                                    <div class="input-group-farm">
                                        <label>Length (ft)</label>
                                        <div class="display-field">
                                            {{ partition.length }}
                                        </div>
                                    </div>
                                    <div class="input-group-farm">
                                        <label>Capacity</label>
                                        <div class="display-field">
                                            {{ partition.capacity }}
                                        </div>
                                    </div>
                                </div>
                                <!-- SENSORS - HIDE UI
                            <div class="partition-form-row">
                                <div class="input-group-farm sensor-selection">
                                    <label>Assigned Sensors</label>
                                    <div class="display-field sensors-list">
                                        {{ getSensorNames(partition.sensors) }}
                                    </div>
                                </div>
                            </div>
                            --></div>

                            <div
                                class="empty-state"
                                *ngIf="
                                    !house.farmHousePartitions ||
                                    house.farmHousePartitions.length === 0
                                "
                            >
                                <i class="fas fa-th-large"></i>
                                <p>No partitions configured for this house</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </section>

        <section
            class="farm-section no-farmhouses"
            *ngIf="!farm.farmHouses || farm.farmHouses.length === 0"
        >
            <div class="empty-state">
                <i class="fas fa-home"></i>
                <p>No farm houses configured</p>
            </div>
        </section>
    </div>
</div>

<!-- Error State -->
<div class="error-container" *ngIf="!farm && (isLoading$ | async) === false">
    <div class="error-content">
        <i class="fas fa-exclamation-triangle text-warning"></i>
        <h3>Farm Not Found</h3>
        <p>
            The requested farm could not be found or you don't have permission
            to view it.
        </p>
        <button class="btn btn-action" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            Back to Farms
        </button>
    </div>
</div>
